import { useEffect } from "react"
import { useAppContext } from "@contexts/app"

export default function useTitle(title?: string) {
    const { setTitle } = useAppContext()

    useEffect(() => {
        setTitle(title)
        return () => setTitle(undefined)
    }, [title])
}